import * as SwitchPrimitive from '@radix-ui/react-switch';

import { cn } from '../../lib/utils';
import type { ToggleProps } from './types';

function Toggle({ className, ...props }: ToggleProps) {
  return (
    <SwitchPrimitive.Root
      data-slot='switch'
      className={cn(
        'eye:peer eye:inline-flex eye:h-24 eye:w-[45px] eye:shrink-0 eye:cursor-pointer eye:items-center eye:rounded-lg eye:border-none eye:outline-black eye:transition-[background-color,box-shadow] eye:duration-200 eye:ease-out eye:focus-visible:outline-2 eye:focus-visible:outline-offset-2 eye:focus-visible:outline-black eye:disabled:cursor-not-allowed eye:data-[state=checked]:bg-blue-100 eye:data-[state=unchecked]:bg-grey-100 eye:[&]:disabled:bg-grey-disabled',
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot='switch-thumb'
        className={cn(
          'eye:pointer-events-none eye:block eye:size-[21px] eye:rounded-full eye:bg-white eye:transition-transform eye:duration-200 eye:ease-out eye:data-[state=checked]:translate-x-[22.5px] eye:data-[state=unchecked]:translate-x-[1.5px]',
        )}
      />
    </SwitchPrimitive.Root>
  );
}

export { Toggle };
